import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UnifiedAuthService } from 'app/services/yoklama/auth.service';
// varsa; yoksa Date.now kullanılıyor
import { CMSDynamicService } from 'app/services/yoklama/cms-service';
import { UtcTimeService } from 'app/services/yoklama/utc-service';
import { YoklamaStateService } from '../ders-baslat/core/yoklama_state_service';
import { CustomToastrService, ToastrMessageType, ToastrPosition } from 'app/base/services/custom-toast-service';
import { environment } from 'environments/environment';
import { version } from 'os';

@Component({
  selector: 'app-hoca-ders-programi',
  templateUrl: './hoca-ders-programi.component.html',
  styleUrls: ['./hoca-ders-programi.component.css'],
})
export class HocaDersProgramiComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  weekdays: string[] = ['Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma'];
  selectedTab = 0;

  isLoading = true;
  items: any[] = []; // DersModel[] varsa onu kullanabilirsin

  // Basit "route observer" benzeri davranış istersen Router events ile ekleyebilirsin.
  private _isReturning = false;
 state$ = this.state.state$;
  constructor(
    public state: YoklamaStateService,
    private router: Router,
     public alertService: CustomToastrService,
    private syllabusService: CMSDynamicService,
   private authService: UnifiedAuthService,
    private fetchUtcService: UtcTimeService // opsiyonel, yoksa fallback Date.now kullanılır
  ) {


  }

  ngOnInit(): void {
     this.state.reset();
    this.selectedTab = this.getWeekdayNumber();
    this.loadData();
  }

  ngAfterViewInit() {
    const slider = document.querySelector('.draggable-tabs') as HTMLElement;
    let isDown = false;
    let startX: number;
    let scrollLeft: number;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('active');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1; // hız
      slider.scrollLeft = scrollLeft - walk;
    });
  }
  ngOnDestroy(): void {
    // temizleme gerekiyorsa yap
  }

  // ---------------- DATA ----------------
async loadData() {
  this.isLoading = true;

  try {
    const dataList = await this.syllabusService.get(
      0,
      2000,
      'Kapi',
      'GetListCourseStart?okulno=' + this.authService.userValue?.data[0].tcNo + '&version=$version'
    );


    // 🔴 YOKLAMA NO 0 OLANLARI FİLTRELE
    this.items = (dataList?.hocaDers || []);



  } catch (err) {
    console.error('Hoca syllabus fetch error', err);
    this.items = [];
  } finally {
    this.isLoading = false;
  }
}

async refreshData() {
  this.isLoading = true;
  this.items = [];
  try {
    const dataList = await this.syllabusService.get(
      0,
      2000,
      'Kapi',
      'GetListCourseStart?okulno=' + this.authService.userValue?.data[0].tcNo + '&version=$version'
    );

    // 🔴 YOKLAMA NO 0 OLANLARI FİLTRELE
    this.items = (dataList?.hocaDers || []);

  } catch (err) {
    console.error('refresh error', err);
    this.items = [];
  } finally {
    this.isLoading = false;
  }
}

  // ---------------- UTILS ----------------
  getWeekdayNumber(): number {
    const today = new Date().getDay(); // 0 pazar, 1 pazartesi
    return today === 0 ? 0 : today - 1;
  }

filterByDay(day: string) {
  const filtered = this.items.filter(x => x.gunAdi === day);

  // 1) acilanDersNo'ya göre grupla
  const map = new Map<number, any[]>();

  filtered.forEach(item => {
    const key = item.acilanDersNo;

    if (!map.has(key)) {
      map.set(key, []);
    }

    map.get(key)!.push(item);
  });

  // 2) her grup için öncelik seç
  const result: any[] = [];

  map.forEach(group => {
    // yoklamaNo > 0 olanlar varsa onları al
    const withYoklama = group.filter(x => x.yoklamaNo > 0);

    if (withYoklama.length > 0) {
      result.push(...withYoklama);
    } else {
      // yoksa 0 olanları al
      result.push(...group);
    }
  });

  // 3) sırala
  return result.sort((a, b) => {
    const aTime = a.baslangicSaati || '';
    const bTime = b.baslangicSaati || '';
    return aTime.localeCompare(bTime);
  });
}

  formatTimeRange(start: string, end: string) {
    const s = start ? start.substring(0, 5) : '';
    const e = end ? end.substring(0, 5) : '';
    return `${s} - ${e}`;
  }

  getDateTimeFromWeekAndGunNo(gunNo: number, saat: string): Date {
    // Haftanın Pazartesi'sini bul (hafta pazartesiden başlıyorsa)
    const now = new Date();
    const pazartesi = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() - (now.getDay() === 0 ? 6 : now.getDay() - 1)
    );
    const dersGunTarihi = new Date(
      pazartesi.getFullYear(),
      pazartesi.getMonth(),
      pazartesi.getDate() + (gunNo - 1)
    );
    // saat "HH:mm:ss" bekleniyor
    const parts = (saat || '00:00:00').split(':').map((p) => parseInt(p, 10));
    const saatInt = parts[0] || 0;
    const dakikaInt = parts[1] || 0;
    const saniyeInt = parts[2] || 0;
    return new Date(
      dersGunTarihi.getFullYear(),
      dersGunTarihi.getMonth(),
      dersGunTarihi.getDate(),
      saatInt,
      dakikaInt,
      saniyeInt
    );
  }

  // ---------------- ZAMAN KONTROL ----------------
  // Flutter'daki isNowInRange fonksiyonunun aynısı: ders başlangıcından 3 dakika önce ile ders bitişi arası true döner
  async isNowInRange(
    baslangicSaati: string,
    bitisSaati: string
  ): Promise<boolean> {
    let now: Date = new Date();
    try {
      if (this.fetchUtcService && this.fetchUtcService.fetchUtcTime) {
        const fetched = await this.fetchUtcService.fetchUtcTime();
        if (fetched) now = new Date(fetched);
      }
    } catch (e) {
      // fallback to local time
      now = new Date();
    }

    const [sh, sm] = baslangicSaati.split(':').map((s) => parseInt(s, 10));
    const [eh, em] = bitisSaati.split(':').map((s) => parseInt(s, 10));

    const startTime = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      sh,
      sm
    );
    const endTime = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      eh,
      em
    );
    const startWithBuffer = new Date(startTime.getTime() - 3 * 60 * 1000);


    return now > startWithBuffer && now < endTime;
  }

  // ---------------- PREFERENCES (localStorage) ----------------
  async saveCourseStartDataToPrefs(payload: {
    courseId: number;
    dersBaslangic: Date;
    dersBitis: Date;
    haftalikDersId: number;
    slotCount: number;
    totalSessionHours: number;
    attendanceDuration: number;
    courseStartId: number;
    createdDate: Date;
    teacherId: string;
    ogrenciler: any[];
    dersbasldimi: boolean;
    yoklamaPeriyodu: string;
    acilanDersDetayNo: number;
    akademikPersonelNo: number;
    acilanDersNo:number;
    gun:number;
    qrUretimAktif:boolean,
    konumKontrolAktif:boolean,
    latitude: number;
    longitude: number;
    kampusLatitude: number;
    kampusLongitude: number;
    binaLatitude: number;
    binaLongitude: number;
    dersAd:string;
    dersAdres:string;
  }) {


    const data = {
      courseId: payload.courseId,
      dersBaslangic: payload.dersBaslangic.toISOString(),
      dersBitis: payload.dersBitis.toISOString(),
      haftalikDersId: payload.haftalikDersId,
      slotCount: payload.slotCount,
      totalSessionHours: payload.totalSessionHours,
      attendanceDuration: payload.attendanceDuration,
      courseStartId: payload.courseStartId,
      createdDate: payload.createdDate.toISOString(),
      teacherId: payload.teacherId,
      Ogrenciler: payload.ogrenciler,
      dersbasldimi: payload.dersbasldimi,
      yoklamaPeriyodu: payload.yoklamaPeriyodu,
      acilanDersDetayNo: payload.acilanDersDetayNo,
      akademikPersonelNo: payload.akademikPersonelNo,
      acilanDersNo: payload.acilanDersNo,
      gun: payload.gun ?? 1,
      qrUretAktif:payload.qrUretimAktif,
      konumKontrolAktif:payload.konumKontrolAktif,
   latitude: payload.latitude ?? 0,
  longitude: payload.longitude ?? 0,
  kampusLatitude: payload.kampusLatitude ?? 0,
  kampusLongitude: payload.kampusLongitude ?? 0,
  binaLatitude: payload.binaLatitude ?? 0,
  binaLongitude: payload.binaLongitude ?? 0,
  dersAd:payload.dersAd,
  dersAdres:payload.dersAdres,

    };

    await this.removeCourseStartDataFromPrefs();

    await localStorage.setItem('courseStartPageData', JSON.stringify(data));


  }

  removeCourseStartDataFromPrefs() {
    localStorage.removeItem('Ogrenciler');
    localStorage.removeItem('dersbasldimi');
    localStorage.removeItem('yoklamaPeriyodu');
    localStorage.removeItem('YOKLAMA_STATE');
    localStorage.removeItem('dersBaslangic');
    localStorage.removeItem('dersBitis');
    localStorage.removeItem('courseStartPageData');
  }
getButtonClass(item: any): string {
  // Yoklama metni üzerinden veya item içindeki bir 'status' property'si üzerinden kontrol edilebilir
  const text = this.yoklamaText(item);

  if (text === 'Yoklama Başlat') {
    return 'btn-warning text-dark'; // Henüz başlamamış (Sarı)
  }

  if (text.includes('Devam Ettir') || text === 'OBS\'ye Aktar') {
    return 'btn-success text-white'; // Aktif veya tamamlanmak üzere (Yeşil)
  }

  if (text === 'Yoklama Bitti') {
    return 'btn-danger text-white'; // Kapatılmış (Kırmızı)
  }

  return 'btn-primary'; // Varsayılan (Mavi)
}

// İsterseniz sol taraftaki ince şerit için de benzer bir mantık kullanabiliriz
getStatusClass(item: any): string {
  const text = this.yoklamaText(item);
  if (text === 'Yoklama Başlat') return 'bg-started';
  if (text.includes('Devam Ettir')) return 'bg-active';
  if (text === 'Yoklama Bitti') return 'bg-finished';
  return '';
}
  // ---------------- YOKLAMA METNI ----------------
  yoklamaText(item: any): string {
    const info = item?.attendanceInfo;
    if (!info) return 'Yoklama Başlat';
  if (info.attendanceMode === 'teksefer') {
    if (info.obsStatus === true) {
      return 'Yoklama Bitti';
    } else {
      return 'OBS\'ye Aktar ';
    }
  }

    if (info.slotCount === 0) {
      if (info.obsStatus) return 'Yoklama Bitti';
      return `Yoklamayı Devam Ettir / ${info.totalSessionHours}. Saat`;
    } else if (info.slotCount > 0 && info.obsStatus === false) {
      const mevcut = info.totalSessionHours - (info.slotCount-1);
      return `Yoklamayı Devam Ettir / ${mevcut}. Saat`;
    }
    return 'Yoklama OBS\'ye Aktarıldı';
  }

  // ---------------- DERS BAŞLAT BUTONU AKSİYONU ----------------
  async onStartAttendance(syllabus: any) {
    let yoklamaText = this.yoklamaText(syllabus);

    // Burada Flutter'daki kontrolü (isNowInRange) kullan
    let control = true;
    try {
      control = await this.isNowInRange(
        syllabus.baslangicSaati.substring(0, 5),
        syllabus.bitisSaati.substring(0, 5)
      );
      //control =true;
    } catch (e) {
      control = false; // fallback
    }

    if (!control) {
      // Angular'da snackbar yoksa window.alert kullan; projende Toastr/MatSnackBar varsa onu kullan
      this.alertService.message(
        'Yoklamayı yalnızca ders başlamadan 3 dakika önce ile ders bitimine kadar alabilirsiniz.','Uyarı',

{ messageType: ToastrMessageType.Warning, position: ToastrPosition.TopFullWidth   }
      );
      return;
    }

    if (yoklamaText === 'Yoklama Bitti') {
      this.alertService.message(
        "OBS'ye Aktarılan Yoklama Üzerinde İşlem Yapılmaz. Lütfen OBS Üzerinden Kontrol Edin.",
        'Uyarı',
        { messageType: ToastrMessageType.Warning, position: ToastrPosition.TopFullWidth }
      );
      return;
    }

    // Kaydetme işlemleri (flutter'dakine paralel)
    this.removeCourseStartDataFromPrefs();

    const ogrenciler =
      syllabus.attendanceInfo && syllabus.attendanceInfo.Ogrenciler
        ? syllabus.attendanceInfo.Ogrenciler
        : syllabus.ogrenciler || [];

    this.saveCourseStartDataToPrefs({
      courseId: syllabus.dersNo,
      dersBaslangic: this.getDateTimeFromWeekAndGunNo(
        syllabus.gunNo,
        syllabus.baslangicSaati
      ),
      dersBitis: this.getDateTimeFromWeekAndGunNo(
        syllabus.gunNo,
        syllabus.bitisSaati
      ),
      haftalikDersId: syllabus.yoklamaNo || 0,
      slotCount: syllabus.attendanceInfo?.slotCount ?? 0,
      totalSessionHours: syllabus.attendanceInfo?.totalSessionHours ?? 0,
      attendanceDuration: syllabus.attendanceInfo?.attendanceDuration ?? 0,
      courseStartId: syllabus.attendanceInfo?.courseStartId ?? 0,
      createdDate: syllabus.attendanceInfo?.createdDate
        ? new Date(syllabus.attendanceInfo.createdDate)
        : new Date(),
      teacherId: syllabus.tcKimlikNo ?? '',
      ogrenciler: ogrenciler,
     dersbasldimi: syllabus.attendanceInfo == null ||
              ((syllabus.attendanceInfo != null) && ((syllabus.attendanceInfo.slotCount ?? 0) > 0)),

      yoklamaPeriyodu: syllabus.attendanceInfo?.attendanceMode ?? '',
      acilanDersDetayNo: syllabus.acilanDersDetayNo || 0,
      akademikPersonelNo: syllabus.akademikPersonelNo || 0,
      acilanDersNo: syllabus.acilanDersNo || 0,
      gun: syllabus.gunNo || 1,
      qrUretimAktif:syllabus.attendanceInfo?.qrUretAktif,
      konumKontrolAktif:syllabus.attendanceInfo?.konumKontrolAktif,

      latitude: syllabus.attendanceInfo?.locationLatitude,
      longitude: syllabus.attendanceInfo?.locationLongitude,
      kampusLatitude: syllabus.attendanceInfo?.kampusLatitude,
      kampusLongitude: syllabus.attendanceInfo?.kampusLongitude,
      binaLatitude: syllabus.attendanceInfo?.binaLatitude,
      binaLongitude: syllabus.attendanceInfo?.binaLongitude,
      dersAd:syllabus.dersAdi,
      dersAdres:syllabus.derslik,
    });

    // RouteStorageService benzeri bir yapı yoksa doğrudan navigate et
    this.router.navigate(['/ders-yoklama-baslat',{ version: environment.version }], { replaceUrl: true });
  }
}
